import { useEffect, useState, useRef, useCallback } from 'react';
import Icon from '../ui/Icon.jsx';
import NotificationDropdown from './NotificationDropdown.jsx';
import { getUnreadCount } from '../api.js';

const POLL_INTERVAL = 30_000;

export default function NotificationBell() {
  const [count, setCount] = useState(0);
  const [open, setOpen] = useState(false);
  const bellRef = useRef(null);

  const refresh = useCallback(() => {
    let cancelled = false;
    getUnreadCount()
      .then((data) => { if (!cancelled) setCount(data.count); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    const cancel = refresh();
    const id = setInterval(refresh, POLL_INTERVAL);
    return () => { cancel(); clearInterval(id); };
  }, [refresh]);

  const toggle = () => setOpen((prev) => !prev);

  const onClose = () => {
    setOpen(false);
    refresh();
  };

  return (
    <div className="notification-bell" ref={bellRef}>
      <button type="button" className="icon-button quiet" onClick={toggle}
              aria-label="Notifications" title="Notifications">
        <Icon name="bell" />
        {count > 0 && (
          <span className="notification-badge">{count > 9 ? '9+' : count}</span>
        )}
      </button>
      {open && <NotificationDropdown anchorRef={bellRef} onClose={onClose} />}
    </div>
  );
}
